import React, { useRef, useEffect, useState } from 'react';

const Select = ({ label, options, value, onChange }) => {
    const selectRef = useRef(null);
    const hiddenSpanRef = useRef(null);
    const [selectWidth, setSelectWidth] = useState('auto');

    const getCurrentOptionLabel = () => {
        const currentOption = options.find(option => option.value === value);
        return currentOption ? currentOption.label : '';
    };

    useEffect(() => {
        if (hiddenSpanRef.current && selectRef.current) {
            hiddenSpanRef.current.textContent = getCurrentOptionLabel();

            const textWidth = hiddenSpanRef.current.offsetWidth;
            const paddingAndIcon = 20;
            if (textWidth)
                setSelectWidth(`${textWidth + paddingAndIcon}px`);
        }
    }, [value, options]);

    return (
        <div className='form-item form-item--select form-item--horizontal'>
            <label className='select-label' htmlFor="items-per-page">{label}</label>
            <select
                ref={selectRef}
                className='select__select select__select--ghost select-icon h-text-align-right'
                value={value}
                onChange={onChange}
                style={{ width: selectWidth }}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {/* Hidden span to measure text width */}
            <span
                ref={hiddenSpanRef}
                style={{
                    position: 'absolute',
                    visibility: 'hidden',
                    whiteSpace: 'nowrap',
                    fontSize: 'inherit',
                    fontFamily: 'inherit',
                    fontWeight: 'inherit'
                }}
                aria-hidden="true"
            />
        </div>
    );
};

export default Select;
